import { authenticatedCompanyFormType, legal_entity } from "@/features/company/types";
import { DeepPartial } from "react-hook-form";

export const buildDefaultValuesFromCompany = (
  legalEntity: legal_entity
): DeepPartial<authenticatedCompanyFormType> => {
  return {
    ShareCapital: legalEntity.ShareCapital ?? undefined,
    ActivityRequiredAgreement: legalEntity.ActivityRequiredAgreement ?? null,
    AmlObligations: legalEntity.AmlObligations ?? null,
    Comments: legalEntity.Comments ?? null,
    FiancialYearDocument: legalEntity.FiancialYearDocument ?? null,
    OrganizationalDocument: legalEntity.OrganizationalDocument ?? null,
    RbeDocument: legalEntity.RbeDocument ?? null,
    SecondIdentityDocument: legalEntity.SecondIdentityDocument ?? null,
    CompanyIban: legalEntity.CompanyIban ?? null
  };
};
